<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uFm966Hj7iYbq2KensB5yj6">Prologue</p>
<p class="FIRSTPARAGRAPH">The rain had stopped. The afternoon sun had resumed its assault on rotting corn shocks, casting distorted shadows across the abandoned farm. A pair of cicadas sounded, silencing the chirping of the nearby sparrows, sending them into flight.</p>
<p class="Normal">In the middle of the field, a sturdy youth stood silently, eyes fixed on a mound of fresh clay.</p>
<p class="Normal">A rush of cool air stirred wisps of his ripened-wheat-colored hair. Bending down, he used a finger to inscribe the name ‘Gus’ in the collected soil.</p>
<p class="Normal">A second youth, a female, approached. “Can we go now,” she asked, wearily. “This is our tenth field and there’s nothing left of him to bury.”</p>
<p class="Normal">“In a minute.”</p>
<p class="Normal">The girl looked around. “Someone could be watching, you know.”</p>
<p class="Normal">“Just need a minute.”</p>
<p class="Normal">“Well, you’d better make it a quick one.”</p>
<p class="Normal">The youth’s eyes lingered on the newly formed grave. With a nod of satisfaction, he uprighted himself. As a smile lit his face, he used the heel of his boot to eradicate their victim’s name. “Lovee,” he said, “may the bastard rest in peace.”</p>
<p class="Normal">“You mean in pieces. Let’s go.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?3162d9b6